import styled from 'styled-components';
import React, { useState } from 'react';

import type { IClient } from '@/api/types';

import { useAppSelector, useAppDispatch } from '@/hooks/store';
import { Select } from '../common';
import { setCurrentClient } from '@/store/slices/authSlice';
import { getClientSchedules } from '@/store/slices/scheduleSlice';
import { FULFILLED_ACTION } from '@/config/variables';
import { useHistory } from 'react-router-dom';

interface IClientSelectionComboProps {
  onSelect?: (clientIdStr: string) => void;
}

const ClientSelectionCombo = ({ onSelect }: IClientSelectionComboProps): React.ReactElement => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const availableClients: IClient[] | null | undefined = useAppSelector(state => state.auth.user?.availableClients);
  const currentClient: IClient | null | undefined = useAppSelector(state => state.auth.user?.currentClient);

  const [selectedClientId, setSelectedClientId] = useState<string | undefined>(currentClient?.clientId?.toString());

  const onClientChanged = (clientIdStr: string) => {
    dispatch(setCurrentClient(Number.parseInt(clientIdStr))).then(response => {
      //Redirect to the campaigns' main page if the page is in campaign details page
      if (response.meta.requestStatus === FULFILLED_ACTION) {
        const pageUrl = window.location.href;
        if (pageUrl.includes('/campaigns/')) history.push('/campaigns');
      }
    });
    dispatch(getClientSchedules({ clientId: +clientIdStr }));
    setSelectedClientId(clientIdStr);
    onSelect?.(clientIdStr);
  };

  return (
    <ComboDiv>
      <Select
        name="client-selector"
        options={
          availableClients
            ? availableClients?.map(item => {
                return { value: item.clientId, label: item.clientName };
              })
            : []
        }
        value={selectedClientId}
        onChange={event => onClientChanged(event.target.options[event.target.selectedIndex].value)}
        isStandalone
      />
    </ComboDiv>
  );
};

const ComboDiv = styled.div`
  margin-right: 1.5rem;
`;

export { ClientSelectionCombo };
